import { ReactElement } from "react";
import { Badge } from "@justworkshr/milo-core";

import { MFA_FACTOR_COPY } from "../../../constants/factorCopy";

import { Factor } from "types/factor/factor";

import HeaderDescription from "../headerDescription/HeaderDescription";

import styles from "./header-content.module.css";

const HeaderContent = ({ factor }: { factor: Factor }): ReactElement => {
  const copy = MFA_FACTOR_COPY[factor.key];

  return (
    <>
      <div className={styles.title}>{copy.title}</div>

      {factor.flags.isTotpFactor && (
        <Badge role="info" className={styles.badge}>
          More secure
        </Badge>
      )}

      {factor.flags.isPasskeyFactor && (
        <Badge role="info" className={styles.badge}>
          Most secure
        </Badge>
      )}

      <HeaderDescription factor={factor} />
    </>
  );
};

export default HeaderContent;
